function toNumber(value: unknown): number | null {
	if (value == null) return null;
	if (typeof value === 'number') return Number.isFinite(value) ? value : null;

	if (typeof value === 'string') {
		let s = value.trim();
		if (!s) return null;

		// conservar dígitos, . , y -
		s = s.replace(/[^\d.,-]/g, '');

		// decidir separador decimal por el último que aparezca (.,)
		const lastDot = s.lastIndexOf('.');
		const lastComma = s.lastIndexOf(',');
		const decimalSep = lastDot > lastComma ? '.' : lastComma > -1 ? ',' : '';

		if (decimalSep) {
			const thousandSep = decimalSep === '.' ? ',' : '.';
			s = s.replace(new RegExp('\\' + thousandSep, 'g'), '');
			if (decimalSep === ',') s = s.replace(',', '.');
		} else {
			// sin separador decimal
			s = s.replace(/[.,](?=\d{3}\b)/g, '');
		}

		const n = Number(s);
		return Number.isFinite(n) ? n : null;
	}

	return null;
}

export function numeric(input: unknown, opts: { decimals?: number; locale?: string; nullAs?: string; useGrouping?: boolean } = {}): string {
	const { decimals = 0, locale = 'es-AR', nullAs = '', useGrouping = true } = opts;
	const n = toNumber(input);
	if (n == null) return nullAs;

	try {
		return new Intl.NumberFormat(locale, {
			minimumFractionDigits: decimals,
			maximumFractionDigits: decimals,
			useGrouping,
		}).format(n);
	} catch {
		return n.toFixed(decimals);
	}
}

export function capitalize(input?: string | null): string {
	if (input == null) return '';
	const s = String(input).trim();
	if (!s) return '';
	return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}
